export enum ArrowDirection {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'Left',
  Right = 'Right',
}
